import React, { useMemo } from 'react';
import { unixDiff, unixFormat } from '../../../../../helpers/times';

import './style.scss';

const ScheduleGridTimeLine = ({
    timelineData,
    timelineOffset = 0,
    endOffset = 0,
    schedule = null,
    rowHeight,
    settings = {},
    isStreamsHidden = false,
    children,
}) => {
    const firstScheduleTime = useMemo(() => {
        if (!schedule?.length || !timelineData?.intervals?.length) {
            return null;
        }

        const timeDifference = unixDiff(schedule[0].timeStart, timelineData.intervals[1]);

        return timeDifference >= 15 ? schedule[0].timeStart : null;
    }, [schedule, timelineData]);

    if (!timelineData || !timelineData.intervals?.length) {
        return null;
    }

    return (
        <div className={`schedule-grid-timeline ${isStreamsHidden ? 'streams-hidden' : ''}`}>
            {
                timelineData.intervals.map((interval, index) => (
                    <div
                        key={interval}
                        className={`schedule-grid-timeline__row ${typeof settings?.showGridStripes === 'boolean' && !settings.showGridStripes ? 'schedule-grid-timeline__row--noborder' : ''}`}
                        style={{
                            height: !!timelineOffset && index === 0 ? rowHeight - timelineOffset : rowHeight,
                            maxHeight: index === timelineData.intervals.length - 1 ? endOffset : 'unset',
                        }}
                    >
                        <div className="schedule-grid-timeline__row-time">
                            {   index !== 0
                                ? unixFormat(interval, 'HH:mm')
                                : unixFormat(firstScheduleTime, 'HH:mm')
                            }
                        </div>
                    </div>
                ))
            }
            {
                children
            }
        </div>
    )
};

export default ScheduleGridTimeLine;
